export default __webpack_public_path__ + "static/media/s3-bg-3x.db495463.png";